import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../config/react'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import DataTable from 'react-data-table-component'

const Customers = () => {
  const path = useLocation()
  const [CustomerList, setCustomerList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [CustomerGroupList] = useState([])
  const [ShowFilters, setShowFilters] = useState(false)
  const [loading, setLoading] = useState(true)
  const [IsAuth, setIsAuth] = useState(false)
  const [currentPage, setCurrentPage] = useState(
    path.state ? (parseInt(path.state.state.page) === 0 ? 1 : parseInt(path.state.state.page)) : 1
  )
  const columns = [
    {
      name: 'First Name',
      sortable: true,
      sortField: 'firstname',
      warp: true,
      selector: (row) => row.firstname
    },
    {
      name: 'Email',
      sortable: true,
      sortField: 'email',
      selector: (row) => row.email,
      wrap: true
    },
    {
      name: 'Contact Number',
      selector: (row) => row.contact_number
    },
    {
      name: 'Is Guest',
      selector: (row) => (row.is_guest === 1 ? <label>Yes</label> : <label>No</label>)
    },
    // {
    //     name: 'Email Confirmation',
    //     selector: row => row.is_confirmed == 1 ? <label>Yes</label> : <label>No</label>
    // },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={
              '/customers/edit/' +
              row.id +
              '?name=' +
              CustomFilters.name +
              '&email=' +
              CustomFilters.email +
              '&page=' +
              CustomFilters.page
            }
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          {row.status ? (
            <Link
              onClick={(e) => ChangeStatus(e, row.id, 0)}
              to=""
              className="text-dark"
              title="Inactive"
            >
              <i
                className="fa fa-ban"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          ) : (
            <Link
              onClick={(e) => ChangeStatus(e, row.id, 1)}
              to=""
              className="text-dark"
              title="Active"
            >
              <i
                className="fa fa-check"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          )}
          <Link
            onClick={(e) => DeleteCustomer(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  console.log(path)

  const DefaultFilters = {
    customergroup: '',
    name: path.state?.state?.name !== undefined ? path.state.state.name : '',
    email: path.state?.state?.email !== undefined ? path.state.state.email : '',
    page: currentPage,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  console.log(DefaultFilters)

  const [Inputs, setInputs] = useState(DefaultFilters)
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Customers
    GetCustomerList()
    GetCustomerGroupList()
  }, [CustomFilters])

  const GetCustomerList = () => {
    const customerData = {
      customergroup: CustomFilters.customergroup,
      name: CustomFilters.name,
      email: CustomFilters.email,
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetCustomerAdminList, customerData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        setCustomerList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }

  const DeleteCustomer = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteCustomer, param).then((response) => {
          setLoading(false)
          if (response.data.status === true) {
            toast.success(Messages.RecordDeleted)
            GetCustomerList()
          }
        })
      }
    })
  }
  const ChangeStatus = async (e, id, status) => {
    e.preventDefault()
    swal({
      title: Messages.Confirm,
      text: status ? Messages.ConfirmEnable : Messages.ConfirmDisable,
      buttons: {
        cancel: true,
        confirm: true
      }
    }).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          status
        }
        setLoading(true)
        HttpService.postApi(API.ChangeCustomerStatus, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordUpdated)
          GetCustomerList()
        })
      }
    })
  }
  const GetCustomerGroupList = () => {
    setLoading(true)
    HttpService.postApi(API.GetCustomerGroups, null).then((response) => {
      setLoading(false)
      const obj = []
      response.data.result[0].map((item, index) => {
        obj.push({ label: item.name, value: item.id })
        return true
      })
      Object.assign(CustomerGroupList, obj)
    })
  }
  const handleInputChanges = (e, fieldName) => {
    if (fieldName === 'customergroup') Object.assign(CustomFilters, { [fieldName]: e })
    else Object.assign(CustomFilters, { [fieldName]: e.target.value })

    setInputs({ ...Inputs, [fieldName]: e.target.value })
  }

  const openFilterBox = () => {
    if (ShowFilters) {
      setShowFilters(false)
    } else {
      setShowFilters(true)
    }
  }

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For First Name, Email, Contact Number."
        className="form-control col-md-3"
        placeholder="Search"
        value={CustomFilters.search}
        onChange={(e) =>
          setCustomFilters({ ...CustomFilters, page: currentPage, search: e.target.value })
        }
      />
    )
  })
  const clearAllFilter = (e) => {
    setCustomFilters(DefaultFilters)
    setInputs(DefaultFilters)
    setForceUpdate(!isForceUpdate)
  }
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const handleExportExcel = () => {
    HttpService.postApi(API.GetCustomerExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Customers')
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Customers} </h3>
        <div className="btn-group">
          <Link
            to={
              '/customers/add' +
              '?name=' +
              CustomFilters.name +
              '&email=' +
              CustomFilters.email +
              '&page=' +
              CustomFilters.page
            }
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Customer{' '}
          </Link>
          <Link
            to="#"
            onClick={openFilterBox}
            className="btn btn-primary btn-fw rounded filter-btn mr-2"
          >
            {' '}
            Filters{' '}
          </Link>
        </div>
      </div>
      <div
        className={ShowFilters ? 'filter-bar d-block' : 'filter-bar'}
        id="filter-bar"
      >
        <div className="grid-margin w-100 stretch-card">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Name</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={(e) => handleInputChanges(e, 'name')}
                        value={Inputs.name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Email</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        onChange={(e) => handleInputChanges(e, 'email')}
                        value={Inputs.email}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 mt-4">
                    <div className="btn-group">
                      <Link
                        to="#"
                        className="btn btn-custom text-white btn-fw-130 rounded mr-2"
                        onClick={(e) => GetCustomerList(e)}
                      >
                        {' '}
                        Apply{' '}
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-primary btn-fw-130 rounded mr-2"
                        onClick={(e) => clearAllFilter(e)}
                      >
                        {' '}
                        Reset
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={CustomerList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationDefaultPage={currentPage}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                />

                {/* <MaterialTable
                                    title=""
                                    columns={[
                                        { title: 'First Name', field: 'firstname' },
                                        { title: 'Email', field: 'email' },
                                        { title: 'Contact Number', field: 'contact_number' },
                                        {
                                            title: 'Is Guest', field: 'is_guest',
                                            render: rowData => rowData.is_guest == 1 ? <label>Yes</label> : <label>No</label>
                                        },
                                        {
                                            title: 'Email Confirmation', field: 'is_confirmed',
                                            render: rowData => rowData.is_confirmed == 1 ? <label>Yes</label> : <label>No</label>
                                        },
                                        {
                                            title: 'Created Date', field: 'created_at', type: 'datetime',
                                            render: rowData => <DateFormat value={rowData.created_at}></DateFormat>
                                        },
                                        {
                                            title: 'Status', field: 'status',
                                            render: rowData => rowData.status == 1 ? <label>Active</label> : <label>Inactive</label>
                                        },
                                        {
                                            title: 'Action', field: 'id', className: "table_icon", sorting: false,
                                            render: rowData =>
                                                <div className="action-btn">
                                                    <Link to={"/customers/edit/" + rowData.id} className="text-dark" title="Edit"><i className="fa fa-pencil-square-o" aria-hidden="true"></i> </Link>
                                                    {
                                                        rowData.status ?
                                                            <Link onClick={e => ChangeStatus(e, rowData.id, 0)} to="" className="text-dark" title="Disable" ><i className="fa fa-ban" aria-hidden="true"></i> </Link>
                                                            :
                                                            <Link onClick={e => ChangeStatus(e, rowData.id, 1)} to="" className="text-dark" title="Enable" ><i className="fa fa-check" aria-hidden="true"></i> </Link>
                                                    }
                                                    <Link onClick={e => DeleteCustomer(e, rowData.id)} to="" className="text-dark" title="Delete" ><i className="fa fa-trash-o" aria-hidden="true"></i> </Link>
                                                </div>
                                        }
                                    ]}

                                    data={CustomerList}
                                    options={{
                                        thirdSortClick: false,
                                        //exportButton: true,
                                        pageSize: 10,
                                        emptyRowsWhenPaging: false,
                                        //filtering: true,
                                        exportCsv: (columns, data) => {
                                            alert('You should develop a code to export ' + data.length + ' rows');
                                        },

                                    }}
                                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Customers
